import fonts from "../../../styles/fonts";
import palette from "../../../styles/palette";
import position from "../../../styles/position";

export default {
    fabBg: {
        ...position.fixedFill,
        backgroundColor: "white",
        opacity: 0.9
    },
    fabPosition: {
        position: "fixed",
        right: "3%",
        bottom: "5%",
        textAlign: "right",
    } as React.CSSProperties,
    fab: {
        backgroundColor: "rgb(20, 207, 176)",
        color: "white",
        marginBottom: 10,
        position: "relative"
    } as React.CSSProperties,
    fabRoot: {
        marginTop: 20,
    },
    fabLabel: {
        ...fonts.tooltip,
        opacity: 0.9,
        position: "absolute",
        textTransform: "none",
        color: "white",
        right: 80,
        whiteSpace: "nowrap",
        backgroundColor: palette.bg.tooltip,
        paddingTop: 5,
        paddingBottom: 5,
        paddingLeft: 10,
        paddingRight: 10,
        borderRadius: 5
    } as React.CSSProperties,
    fabClose: {
        backgroundColor: "rgb(203, 36, 49)",
    }
}